import { t } from "@lingui/core/macro";

export function successMessage(type, name) {
  return type === "add" ? t`${name} added to favorites.` : t`${name} removed from favorites.`;
}

export function failedMessage(type, name) {
  return type === "add"
    ? t`Failed to add ${name} to favorites.`
    : t`Failed to remove ${name} from favorites.`;
}
